<template>
  <section class="zlc-right-content">
    <Head></Head>
    <div class="zlc-content-scroll">
      <div class="zlc-content-inner"><router-view /></div>
      <footer class="zlc-footer">智联车途 · 企业安全生产管理平台 <span>专注交通运输安全管理</span></footer>
    </div>
  </section>
</template>
<script>
import Head from '@/views/layout/Head.vue';
export default {components:{Head}, inject:['baseInfo']};
</script>
<style scoped>
.zlc-right-content{flex:1;min-width:0;display:flex;flex-direction:column;height:100vh;overflow:hidden}.zlc-content-scroll{flex:1;overflow-y:auto;overflow-x:hidden}.zlc-content-inner{padding:23px 26px 16px;min-height:calc(100% - 62px)}.zlc-footer{text-align:center;color:#94a3b8;padding:13px 0 23px;font-size:12px}.zlc-footer span{padding-left:13px;margin-left:10px;border-left:1px solid #d6deea}
</style>



// WEBPACK FOOTER //
// src/views/layout/RightContent.vue